export const EULA_LATEST_QUERY = (eulaId: string, locale: string): string => `
{
    Eula {
        getLatestAndConvert(id: "${eulaId}", locale: "${locale}"){
            key
            title
            body
            version
            locale
        }
    }
}`;

export const EULA_VERSIONED_QUERY = (eulaId: string, version: number, locale: string): string => `
{
    Eula {
        getEulaVersion(id: "${eulaId}", version: ${version} locale: "${locale}"){
            key
            title
            body
            version
            revision
            locale
        }
    }
}`;

export const EULA_ACCEPTED_QUERY = (eulaId: string, locale: string, accountId: string): string => `
{
    Eula {
        hasAccountAccepted(id: "${eulaId}", locale: "${locale}", accountId: "${accountId}"){
            accepted
            key
            locale
            version
        }
    }
}`;

export const EULA_ACCEPT_MUTATION = (
	eulaId: string,
	locale: string,
	accountId: string,
	version: number
): string => `
mutation {
    Eula {
        acceptEula(id: "${eulaId}", locale: "${locale}", accountId: "${accountId}", version: ${version || 0}){
            accepted
            version
        }
    }
}`;
